import { Component, OnInit, OnDestroy, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators, ValidationErrors, UntypedFormBuilder, Form } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserModel } from '../../../models/user.model';
import { UserService } from '../../services/userService.service';
import { MessageService } from '../../services/messageService.service';
import { Subscription, Observable } from 'node_modules/rxjs';
import { map, first } from 'rxjs/operators';
import { ReCaptchaV3Service, OnExecuteData } from 'ng-recaptcha';
import { ReportService } from '@src/app/services/reportService.service';
import { UserFilterModel, FilterModel } from '@src/models/filter.model';
import Utils from '@src/app/helpers/Utils';
import { DateAdapter } from '@angular/material/core';
import { environment } from '../../../environments/environment';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-criteriaform',
    templateUrl: './criteriaform.component.html',
    styleUrls: ['./criteriaform.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class CriteriaformComponent implements OnInit, OnDestroy {

  @Output() searchFilter = new EventEmitter<UserFilterModel>();

  criteriaForm!: UntypedFormGroup;
  // customerIdentifierActive: boolean;
  // birthDateActive: boolean;
  public datemask = {
    guide: true,
    showMask : true,
    mask: [/\d/, /\d/, '-', /\d/, /\d/, '-',/\d/, /\d/,/\d/, /\d/]
  };
  matcher = new MyErrorStateMatcher();
  message: string;
  loading = false;
  subscription: Subscription;
  state$: Observable<object>;
  minDate: Date;
  maxDate: Date;
  private allExecutionsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;
  public recentToken: string = '';
  public errors = [];
  public readonly executionLog: OnExecuteData[] = [];
  bookType = "KBK";


  constructor(
    public activatedRoute: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private formBuilder: UntypedFormBuilder,
    private dateAdapter: DateAdapter<any>
    ) {
      const currentYear = new Date().getFullYear();
      this.minDate = new Date(currentYear - 80, 0, 1);
      this.maxDate = new Date(currentYear - 14, 0, 1);

      let envLang = sessionStorage.getItem(environment.sessionLang);
      // Find the position of the hyphen
      if(envLang == null){
        envLang = 'pl-PL';
      }
      let hyphenIndex = envLang.indexOf('-');

      // Extract characters up to the first hyphen
      let lang = hyphenIndex !== -1 ? envLang.substring(0, hyphenIndex) : envLang;

      this.dateAdapter.setLocale(lang);
    }
  ngOnDestroy(): void {
    if (this.allExecutionsSubscription) {
      this.allExecutionsSubscription.unsubscribe();
    }
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
  }



  ngOnInit() {
    this.criteriaForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      documentNr: [''],
      customerIdentifier: ['']
    });
    this.bookType = Utils.getBookType();
    console.log(this.bookType);
    // this.customerIdentifierActive = (bookType === 'SKFRDriver');
    // this.birthDateActive = (bookType === 'KBW');
    //sessionStorage.removeItem('token');
    this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
      .subscribe((data) => this.executionLog.push(data));
  }
  onSubmit() {
    let custIdentf = this.criteriaForm.get('customerIdentifier').value;
    if(Utils.getBookType() === 'KBW'){
      custIdentf = Utils.convertDate(this.criteriaForm.get('customerIdentifier').value);
    }
    const filter: UserFilterModel = {
      // pageIndex: this.paginator.pageIndex,
      // pageSize: this.pageSize,
      // sortActive: (this.sort.active === 'true'),
      // sortDirection: (this.sort.direction === 'desc') ? 1 : 0,
      // userFilter: {
        documentNr: this.criteriaForm.get('documentNr').value,
        firstName: this.criteriaForm.get('firstName').value,
        lastName: this.criteriaForm.get('lastName').value,
        customerIdentifier: custIdentf,
        companyName: ''
      // }
    };
    this.searchFilter.emit(filter);
    return;


    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('onsubmit')
      .subscribe((token) => {
        this.recentToken = token;

        if (this.criteriaForm.invalid) {
          return;
        }
        //this.reportService.getUsers(true, "asc",)


        // const userDataModel: UserModel = this.criteriaForm.value;
        // userDataModel.TrainingTypeId = +sessionStorage.getItem('selectedExam');

        // this.userService.sendData(userDataModel).subscribe((res) => {
        //   sessionStorage.setItem('token', res.token);
        //   this.router.navigate(['/exam']);
        // });
      },
      (error) => {
        this.errors = [ 'Error trying to verify request (reCaptcha v3)' ];
        console.log(this.errors);
      });
  }
  clearField(name){
    this.criteriaForm.get(name).reset('');
  }

  public executeImportantAction(): void {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => this.handleToken(token));
  }
  handleToken(token){
    console.log(token);
  }
}
export function atLeastOne(...fields: string[]) {
  return (fg: UntypedFormGroup): ValidationErrors | null => {
    return fields.some(fieldName => {
      const field = fg.get(fieldName).value;
      if (typeof field === 'number') { return field && field >= 0 ? true : false; }
      if (typeof field === 'string') { return field && field.length > 1 ? true : false; }
    })
      ? null
      : ({ atLeastOne: 'At least one field has to be provided.' } as ValidationErrors);
  };
}
